import { REMOVE_FROM_COMPARE_PRODUCTS, ADD_TO_COMPARE_PRODUCTS, UPDATE_TO_COMPARE_PRODUCTS, ADD_ALL_TO_COMPARE_PRODUCTS } from '../actions/constants/ActionTypes';
import { FetchCompareRequestTypes } from '../actions/CompareActions';
import { reduceAddAllCompareResponse, reduceAddCompareResponse, reduceCompareFeaturesResponse, reduceRemoveCompareResponse, reduceUpdateCompareResponse } from 'pricing-pages-lib/reducers/Compare';
const initialState = {
  apiNames: [],
  features: []
};

const Features = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case ADD_TO_COMPARE_PRODUCTS:
      {
        return reduceAddCompareResponse({
          payload,
          state: state
        });
      }

    case ADD_ALL_TO_COMPARE_PRODUCTS:
      {
        return reduceAddAllCompareResponse({
          payload,
          state: state
        });
      }

    case REMOVE_FROM_COMPARE_PRODUCTS:
      {
        return reduceRemoveCompareResponse({
          payload,
          state: state
        });
      }

    case UPDATE_TO_COMPARE_PRODUCTS:
      {
        return reduceUpdateCompareResponse({
          payload,
          state: state
        });
      }

    case FetchCompareRequestTypes.RECEIVE:
      {
        const data = payload && payload.data;

        if (data) {
          return reduceCompareFeaturesResponse({
            data,
            state: state
          });
        }

        return state;
      }

    default:
      return state;
  }
};

export default Features;